document.addEventListener('DOMContentLoaded', function() {
    const maxComparsionItems = 2;
    const comparsionKey = 'Comparsion';
    const buttons = document.querySelectorAll('.comparsion__btn');
    const comparsionBox = document.querySelector('.comparsion-box');
    const comparsionContent = document.getElementById('comparsion-content');
    const toggleComparsion = document.getElementById('toggle-comparsion');
    const popupInfo = document.querySelector('.comparsion-box__toggle');
    const comparsionCount = document.querySelector('.comparsion-box__count');
    const comparsionUrl = document.querySelector('.comparsion-box__url');
    const overlay = document.querySelector('.comparsion__overlay')
    // Function to update button states
    function updateButtonStates() {
        const productIds = JSON.parse(localStorage.getItem(comparsionKey)) || [];

        buttons.forEach(button => {
            const productId = button.getAttribute('data-compare');

            if (productIds.includes(productId)) {
                button.classList.add('comparsion__btn--active');
                button.classList.remove('comparsion__btn--normal');
                button.classList.remove('comparsion__btn--disable');
            } else if (productIds.length >= maxComparsionItems) {
                button.classList.add('comparsion__btn--disable');
                button.classList.remove('comparsion__btn--normal');
                button.classList.remove('comparsion__btn--active');
            } else {
                button.classList.add('comparsion__btn--normal');
                button.classList.remove('comparsion__btn--active');
                button.classList.remove('comparsion__btn--disable');
            }
        });

        if (productIds.length === 0) {
            comparsionBox.classList.add('comparsion-box--hidden');
            popupInfo.style.height = `${popupInfo.scrollHeight}px`; // Set to the current scroll height for a smooth transition
            requestAnimationFrame(() => {
                popupInfo.style.height = '0';
                popupInfo.classList.remove('comparsion-box__toggle--active');
                toggleComparsion.classList.remove('comparsion-box__btn--active');
            });
            overlay.classList.remove('active');
        } else {
            comparsionBox.classList.remove('comparsion-box--hidden');
        }

        if (productIds.length < maxComparsionItems) {
            comparsionUrl.classList.add('comparsion-box__url--disabled');
        } else {
            comparsionUrl.classList.remove('comparsion-box__url--disabled');
        }

        comparsionCount.textContent = productIds.length;
    }

    // Function to fetch and render comparsion content
    async function renderComparsionContent() {
        const productIds = JSON.parse(localStorage.getItem(comparsionKey)) || [];
        comparsionContent.innerHTML = '';

        if (productIds.length === 0) {
            comparsionContent.innerHTML = '<p>No products in comparsion.</p>';
            return;
        }

        for (const productId of productIds) {
            try {
                const response = await fetch(`/products/${productId}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch product information for ID: ${productId}`);
                }
                const text = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const productTemplate = doc.querySelector('#comparsion-content-template');
                //console.log(doc)
                if (productTemplate) {
                    const productDiv = document.createElement('div');
                    productDiv.classList.add('comparsion-product');
                    productDiv.innerHTML = productTemplate.innerHTML;
                    comparsionContent.appendChild(productDiv);
                } else {
                    console.error(`Product content not found for product ID: ${productId}`);
                }
            } catch (error) {
                console.error('Error fetching product information:', error);
            }
        }
    }

    // Function to remove product from comparsion
    window.removeFromComparsion = function(productHandle) {
        let productIds = JSON.parse(localStorage.getItem(comparsionKey)) || [];
        productIds = productIds.filter(id => id !== productHandle);
        localStorage.setItem(comparsionKey, JSON.stringify(productIds));
        updateButtonStates();
        renderComparsionContent();
    }

    // Attach event listeners to buttons
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const productId = button.getAttribute('data-compare');
            let productIds = JSON.parse(localStorage.getItem(comparsionKey)) || [];

            if (productIds.includes(productId)) {
                productIds = productIds.filter(id => id !== productId);
            } else if (productIds.length < maxComparsionItems) {
                productIds.push(productId);
            }

            localStorage.setItem(comparsionKey, JSON.stringify(productIds));
            updateButtonStates();
            renderComparsionContent();
        });
    });

    // Initial button state update
    updateButtonStates();
    renderComparsionContent();

    // Toggle comparsion box visibility with smooth transition and rotate SVG
    toggleComparsion.addEventListener('click', function() {
        if (popupInfo.classList.contains('comparsion-box__toggle--active')) {
            popupInfo.style.height = `${popupInfo.scrollHeight}px`; // Set to the current scroll height for a smooth transition
            requestAnimationFrame(() => {
                popupInfo.style.height = '0';
                popupInfo.classList.remove('comparsion-box__toggle--active');
                toggleComparsion.classList.remove('comparsion-box__btn--active');
            });
            overlay.classList.remove('active');
        } else {
            popupInfo.classList.add('comparsion-box__toggle--active');
            popupInfo.style.height = `${popupInfo.scrollHeight}px`;
            popupInfo.addEventListener('transitionend', () => {
                if (popupInfo.classList.contains('comparsion-box__toggle--active')) {
                    popupInfo.style.height = 'auto';
                }
            }, { once: true });
            toggleComparsion.classList.add('comparsion-box__btn--active');
            overlay.classList.add('active');
        }
    });

    overlay.addEventListener('click', ()=>{
        popupInfo.style.height = `${popupInfo.scrollHeight}px`; // Set to the current scroll height for a smooth transition
        requestAnimationFrame(() => {
            popupInfo.style.height = '0';
            popupInfo.classList.remove('comparsion-box__toggle--active');
            toggleComparsion.classList.remove('comparsion-box__btn--active');
        });
        overlay.classList.remove('active');
    })

});
